module.exports = __webpack_public_path__ + "static/media/RoroBannerAPP-05.b7de1881.png";